import myaxiosUpload from './axiosFile.service'

function convertObjToFormData(obj)
{
    var formData = new FormData();

    for (var key in obj) {
        formData.append(key, obj[key]);
    }

    formData.append('id', '777')
    formData.append('token', 'MlNykMcT78moIEkwtti4qWP0rwYNNCG')

    return formData
}

const axiosFile = {
    post: async function (obj) {
        return await myaxiosUpload.post('', convertObjToFormData(obj))
    }
}
export default axiosFile
